namespace RioERP.Reports {
    export namespace FranchiseeOutstandingService {
        export const baseUrl = 'Reports/FranchiseeOutstanding';

        export declare function Create(request: Serenity.SaveRequest<FranchiseeOutstandingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FranchiseeOutstandingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FranchiseeOutstandingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FranchiseeOutstandingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Reports/FranchiseeOutstanding/Create",
            Update = "Reports/FranchiseeOutstanding/Update",
            Delete = "Reports/FranchiseeOutstanding/Delete",
            Retrieve = "Reports/FranchiseeOutstanding/Retrieve",
            List = "Reports/FranchiseeOutstanding/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>FranchiseeOutstandingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
